const widgesData = {
  tasks: {
    'task-1': {id: 'task-1', content: 'Work Summary'},
    'task-2': {id: 'task-2', content: 'Message Board'},
    'task-3': {id: 'task-3', content: 'Account Tabs '},
    'task-4': {id: 'task-4', content: 'Calculator '},
  },
  columns: {
    'column-1': {
      id: 'column-1',
      title: 'Default Search',
      taskIds: ['task-1', 'task-2'],
    },
    'column-2': {
      id: 'column-2',
      title: 'Added Queries',
      taskIds: ['task-3', 'task-4'],
    },
  },
  // Facilitate reordering of the columns
  columnOrder: ['column-1', 'column-2'],
};

export default widgesData;
